import React from "react";

const JumboThemeContext = React.createContext({});

export default JumboThemeContext;